import type { WeavyPaywallEntrypointKey } from '@/consts/weavyPaywallEntrypoints.consts';

export enum PricingPageContainer {
  Modal = 'modal',
  Page = 'page',
}

export enum PricingPageEntrypoint {
  BlockedModelPaidPlan = 'blocked_model_paid_plan',
  ImportedModelPaidPlan = 'imported_model_paid_plan',
  LowCredits = 'low_credits',
  UniversalUpgradeBadge = 'UUB',
  EnterpriseUniversalUpgradeBadge = 'enterprise_uub',
  VideoModelPaidPlan = 'video_model_paid_plan',
  VideoModelPaywall = 'VIDEO_MODEL',
  FreeBadge = 'free_badge',
}

export interface PricingPageViewAnalyticsContext {
  entrypoint: PricingPageEntrypoint | WeavyPaywallEntrypointKey;
  model?: string;
  node_definition_id?: string;
}
